import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Alert,
  Badge,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";

//import images
import waterWellSvg from "../../../assets/images/svg/waterWell.svg";
import TableContainer from "Components/Common/TableContainer";
import { numberWithCommas } from "../../../helpers/globalHelper";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useCommonDataFindAllQuery, useWellCreateMutation, useWellDeleteMutation, useWellFindAllQuery, useWellUpdateMutation } from "store";
import DeleteModal from "Components/Common/DeleteModal";
import Dropzone from "react-dropzone";
import Switch from "react-switch";
import ShapeUpload from "Components/fileUpload/ShapeUpload";
import Flatpickr from "react-flatpickr";


const Detail = ({ searchField }: any) => {
  const [customQuery, setCustomQuery] = useState<any>();
  const [modal_backdrop, setmodal_backdrop] = useState(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isLoading, setLoading] = useState(true);

  const [wellOne, setWellOne] = useState<any>();
  const [wellList, setWellList] = useState<any>();
  const [wellCount, setWellCount] = useState<any>();

  const [resetFiles, setResetFiles] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<any>([]);

  // Datatable дээр pagination харуулахад хэрэгтэй
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();

  const { data, error, isFetching } = useWellFindAllQuery(customQuery);

  const [mineralBoolean, setMineralBoolean] = useState<boolean>(false);
  const [save_border, setSave_border] = useState<boolean>(false);

  const [wellUpdate, wellUpdateResult] = useWellUpdateMutation();
  const [wellCreate, wellCreateResult] = useWellCreateMutation();
  const [wellDelete, wellDeleteResult] = useWellDeleteMutation();

  const {
    data: cmn_well_type,
    error: cmn_well_typeError,
    isFetching: isWell_typeFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_well_type`);

  const {
    data: cost_source,
    error: cost_sourceError,
    isFetching: isCost_sourceFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_invesetment_source`);

  useEffect(() => {
    setWellList(data?.data);
    setLoading(false);
    setWellCount(wellList?.length);

    const tempMineral = wellOne !== null ? wellOne?.is_mineral : false;
    setMineralBoolean(tempMineral)

    const tempSave_border = wellOne !== null ? wellOne?.save_border : false;
    setSave_border(tempSave_border)

    setCustomPagination(data?.pagination);
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1
      }&pageSize=${customPageSize !== undefined ? customPageSize : 25}&${searchField !== undefined ? searchField : ''}`;
    setCustomQuery(tempQuery);
  }, [data, wellList, customPageSize, customPageLength, customPagination, searchField]);

  const toggle = useCallback(() => {
    if (modal_backdrop) {
      setmodal_backdrop(false);
      setWellOne(null);
    } else {
      setmodal_backdrop(true);
    }
  }, [modal_backdrop]);

  const handleJobClick = useCallback((arg: any) => {
    const wellData = arg;

    setWellOne({
      id: wellData.id,
      code: wellData.code,
      cmn_well_type: wellData.cmn_well_type,
      decision_info: wellData.decision_info,
      building_design: wellData.building_design,
      budget_cost: wellData.budget_cost,
      cmn_invesetment_source: wellData.cmn_invesetment_source,
      used_date: wellData.used_date,
      is_allowed: wellData.is_allowed,
      sea_level_m: wellData.sea_level_m,
      save_border_desicion: wellData.save_border_desicion,
      location: wellData.location,
    });
    setMineralBoolean(wellData?.is_mineral)
    setSave_border(wellData?.save_border)

    setIsEdit(true);
    toggle();
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (wellData) => {
    setWellOne(wellData);
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (wellOne) {
      wellDelete(wellOne.id);
      setDeleteModal(false);
    }
  };

  const handleJobClicks = () => {
    setIsEdit(false);
    setWellOne(null);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        header: "№",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Код",
        accessorKey: "code",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Зөвшөөрөл",
        accessorKey: "is_allowed",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => {
          switch (cellProps.row.original.is_allowed) {
            case true:
              return (
                <span className="badge badge-soft-success fw-semibold fs-6 text">
                  Зөвшөөрөлтэй
                </span>
              );
            case false:
              return (
                <span className="badge badge-soft-danger fw-semibold fs-6 text">
                  Зөвшөөрөлгүй
                </span>
              );
            default:
              return (
                <span className="badge badge-soft-warning fw-semibold fs-6 text">
                  Тодорхойгүй
                </span>
              );
          }
        },
      },
      {
        header: "Төрөл",
        accessorKey: "well_type_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Рашаан эсэх",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "is_mineral",
        cell: (cellProps: any) => {
          switch (cellProps.row.original.is_mineral) {
            case true:
              return (
                <span className="badge badge-soft-success fw-semibold fs-6 text">
                  Тийм
                </span>
              );
            default:
              return (
                <span className="badge badge-soft-primary fw-semibold fs-6 text">
                  Үгүй
                </span>
              );
          }
        },
      },
      {
        header: "Байршил",
        accessorKey: "location",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Үйлдэл",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <Link to={`/under/ground/water/well/show/${cellProps.row.original.id}`} className="btn btn-sm btn-soft-primary">
                  <i className="mdi mdi-eye-outline" id="viewtooltip"></i>
                </Link>
                <UncontrolledTooltip placement="top" target="viewtooltip">
                  Харах
                </UncontrolledTooltip>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={(event: any) => {
                    const wellData = cellProps.row.original;
                    event.preventDefault();
                    onClickDelete(wellData);
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Устгах
                  </UncontrolledTooltip>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-warning"
                  onClick={(event: any) => {
                    const wellData = cellProps.row.original;
                    event.preventDefault();
                    handleJobClick(wellData);
                  }}
                >
                  <i className="mdi mdi-pencil-outline" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Засах
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    []
  );

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: wellOne?.id,
      code: wellOne?.code,
      cmn_well_type: wellOne?.cmn_well_type,
      is_mineral: wellOne?.is_mineral,
      decision_info: wellOne?.decision_info,
      building_design: wellOne?.building_design,
      budget_cost: wellOne?.budget_cost,
      cmn_invesetment_source: wellOne?.cmn_invesetment_source,
      used_date: wellOne?.used_date,
      is_allowed: wellOne?.is_allowed,
      sea_level_m: wellOne?.sea_level_m,
      save_border_desicion: wellOne?.save_border_desicion,
      location: wellOne?.location,
    },
    validationSchema: Yup.object({
      code: Yup.string().required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (isEdit) {
        const formData = new FormData();

        formData.append('id', wellOne ? wellOne.id.toString() : '0');
        formData.append('code', values?.code);
        formData.append('cmn_well_type', values?.cmn_well_type);
        formData.append('is_mineral', String(mineralBoolean ?? false));
        formData.append('decision_info', values?.decision_info);
        formData.append('building_design', values?.building_design);
        formData.append('budget_cost', values?.budget_cost);
        formData.append('cmn_invesetment_source', values?.cmn_invesetment_source);
        formData.append('used_date', values?.used_date);
        formData.append('is_allowed', values?.is_allowed);
        formData.append('sea_level_m', values?.sea_level_m);
        formData.append('save_border_desicion', values?.save_border_desicion);
        formData.append('location', values?.location);
        wellUpdate(formData)
      } else {
        const formData = new FormData();

        formData.append('code', values?.code);
        formData.append('cmn_well_type', values?.cmn_well_type);
        formData.append('is_mineral', String(mineralBoolean ?? false));
        formData.append('decision_info', values?.decision_info);
        formData.append('building_design', values?.building_design);
        formData.append('budget_cost', values?.budget_cost);
        formData.append('cmn_invesetment_source', values?.cmn_invesetment_source);
        formData.append('used_date', values?.used_date);
        formData.append('is_allowed', values?.is_allowed);
        formData.append('sea_level_m', values?.sea_level_m);
        formData.append('save_border_desicion', values?.save_border_desicion);
        formData.append('location', values?.location);

        if (selectedFiles && selectedFiles.length > 0) {
          selectedFiles.forEach((file: File, index: number) => {
            formData.append(`shapes`, file);
          });
        }

        wellCreate(formData)
      }
      validation.resetForm();
      setmodal_backdrop(false)
    },
  });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  return (
    <React.Fragment>
      <DeleteModal
        deleteName={wellOne?.name}
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Col xl={9}>
        <Card>
          <CardBody className="border-bottom">
            <div className="d-flex align-items-center">
              <img src={waterWellSvg} alt="" height="50" />
              <div className="flex-grow-1 ms-3">
                <h5 className="fw-semibold">Мэдээлэл</h5>
                <ul className="list-unstyled hstack gap-2 mb-0">
                  <li>
                    <i className="mdi mdi-table-row-height"></i>{" "}
                    <span className="text-muted fw-semibold">
                      Нийт: {numberWithCommas(wellCount)}{" "}
                    </span>
                  </li>
                </ul>
              </div>
              <button
                type="button"
                onClick={() => {
                  toggle();
                  setWellOne(null);
                }}
                className="btn btn-success  btn-label"
              >
                <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр
                нэмэх
              </button>
            </div>
          </CardBody>

          <CardBody>
            <TableContainer
              setCustomPageSize={setCustomPageSize}
              setCustomPageLength={setCustomPageLength}
              customPagination={customPagination}
              columns={columns}
              data={wellList || ""}
              isCustomPageSize={true}
              isPagination={true}
              colWidth={2}
              SearchPlaceholder="Хэрэглэгч хайх . . ."
              tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
              pagination="pagination"
              paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
            />
          </CardBody>
        </Card>
      </Col>

      <Modal
        size="xl"
        isOpen={modal_backdrop}
        toggle={() => {
          toggle();
        }}
        backdrop={"static"}
        id="staticBackdrop"
        centered
      >
        <ModalHeader
          toggle={() => {
            toggle();
          }}
        >
          <div className="h5 modal-title" id="staticBackdropLabel">
            {!!isEdit ? "Худгийн бүртгэл мэдээлэл засах" : "Худгийн бүртгэл мэдээлэл нэмэх"}
          </div>
        </ModalHeader>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <Alert color="warning" className="mb-3">
              <strong className="text-danger">(*)</strong> тэмдэг бүхий талбарыг {""}
              <Link to="#" className="alert-link">
                заавал бөглөх
              </Link>  шаардлагатайг анхаарна уу !!!
            </Alert>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <Label className="text-danger"> Бүртгэлийн дугаар *</Label>
                  <Input
                    name="code"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.code || ""}
                    invalid={
                      validation.touched.code &&
                        validation.errors.code
                        ? true
                        : false
                    }
                  />
                  {validation.touched.code &&
                    validation.errors.code ? (
                    <FormFeedback type="invalid">
                      {validation.errors.code}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger"> далайн түвшинээс дээш метр *</Label>
                  <Input
                    name="sea_level_m"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.sea_level_m || ""}
                    invalid={
                      validation.touched.sea_level_m && validation.errors.sea_level_m
                        ? true
                        : false
                    }
                  />
                  {validation.touched.sea_level_m && validation.errors.sea_level_m ? (
                    <FormFeedback type="invalid">
                      {validation.errors.sea_level_m}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label className="text-danger"> Худагны төрөл *</Label>
                  <Input
                    name="cmn_well_type"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.cmn_well_type || ""}
                    invalid={
                      validation.touched.cmn_well_type &&
                        validation.errors.cmn_well_type
                        ? true
                        : false
                    }
                  >
                    <option disabled value="">Сонгох</option>
                    {cmn_well_type?.data?.map((item, index) => (
                      <option value={item?.id}>{item?.name}</option>
                    ))}

                  </Input>
                  {validation.touched.cmn_well_type &&
                    validation.errors.cmn_well_type ? (
                    <FormFeedback type="invalid">
                      {validation.errors.cmn_well_type}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label className="text-danger">Рашаан эсэх *</Label> <br />
                  <Switch
                    uncheckedIcon={<Offsymbol />}
                    checkedIcon={<OnSymbol />}
                    className="me-1 mb-sm-8 mb-2 ms-3"
                    onColor="#626ed4"
                    onChange={() => {
                      setMineralBoolean(!mineralBoolean);
                    }}
                    checked={mineralBoolean}
                  />
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Хамгаалалтын бүстэй эсэх *</Label> <br />
                  <Switch
                    uncheckedIcon={<Offsymbol />}
                    checkedIcon={<OnSymbol />}
                    className="me-1 mb-sm-8 mb-2 ms-3"
                    onColor="#626ed4"
                    onChange={() => {
                      setSave_border(!save_border);
                    }}
                    checked={save_border}
                  />
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Батлагдсан шийдвэр  *</Label>
                  <Input
                    name="decision_info"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.decision_info || ""}
                    invalid={
                      validation.touched.decision_info && validation.errors.decision_info
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.decision_info && validation.errors.decision_info ? (
                    <FormFeedback status="invalid">
                      {validation.errors.decision_info}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Хамгаалалтын бүсийн шийдвэр</Label>
                  <Input
                    name="building_design"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.building_design || ""}
                    invalid={
                      validation.touched.building_design && validation.errors.building_design
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.building_design && validation.errors.building_design ? (
                    <FormFeedback status="invalid">
                      {validation.errors.building_design}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-3">
                  <Label className="text-danger">Төсөв өртөг  *</Label>
                  <Input
                    name="budget_cost"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.budget_cost || ""}
                    invalid={
                      validation.touched.budget_cost && validation.errors.budget_cost
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.budget_cost && validation.errors.budget_cost ? (
                    <FormFeedback status="invalid">
                      {validation.errors.budget_cost}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">	Хөрөнгө оруулалтын төрөл *</Label>
                  <Input
                    name="cmn_invesetment_source"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.cmn_invesetment_source || ""}
                    invalid={
                      validation.touched.cmn_invesetment_source &&
                        validation.errors.cmn_invesetment_source
                        ? true
                        : false
                    }
                  >
                    <option disabled value="">Сонгох</option>
                    {cost_source?.data?.map((item, index) => (
                      <option value={item?.id}>{item?.name}</option>
                    ))}

                  </Input>
                  {validation.touched.cmn_invesetment_source &&
                    validation.errors.cmn_invesetment_source ? (
                    <FormFeedback type="invalid">
                      {validation.errors.cmn_invesetment_source}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">	Зөвшөөрөлтэй эсэх *</Label>
                  <Input
                    name="is_allowed"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.is_allowed || ""}
                    invalid={
                      validation.touched.is_allowed &&
                        validation.errors.is_allowed
                        ? true
                        : false
                    }
                  >
                    <option value="">Тодорхойгүй</option>
                    <option value="false">Зөвшөөрөлгүй</option>
                    <option value="true">Зөвшөөрөлтэй</option>
                  </Input>
                  {validation.touched.is_allowed &&
                    validation.errors.is_allowed ? (
                    <FormFeedback type="invalid">
                      {validation.errors.is_allowed}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Огноо *</Label>
                  <Flatpickr
                    className="form-control d-block"
                    placeholder="Огноо"
                    name="research_date"
                    value={validation.values.research_date}
                    onChange={(selectDate: Date[]) => {
                      if (selectDate[0]) {
                        const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                          .toISOString()
                          .split('T')[0];
                        validation.setFieldValue('research_date', localDate);
                      }
                    }}
                    options={{
                      altInput: true,
                      altFormat: "Y-m-d",
                      dateFormat: "Y-m-d",
                      enableTime: false,
                    }}
                  />
                  {validation.touched.used_date && validation.errors.used_date ? (
                    <FormFeedback status="invalid">
                      {validation.errors.used_date}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Байршил  *</Label>
                  <Input
                    name="location"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.location || ""}
                    invalid={
                      validation.touched.location && validation.errors.location
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.location && validation.errors.location ? (
                    <FormFeedback status="invalid">
                      {validation.errors.location}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Шийдвэр  *</Label>
                  <Input
                    name="save_border_desicion"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.save_border_desicion || ""}
                    invalid={
                      validation.touched.save_border_desicion && validation.errors.save_border_desicion
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.save_border_desicion && validation.errors.save_border_desicion ? (
                    <FormFeedback status="invalid">
                      {validation.errors.save_border_desicion}
                    </FormFeedback>
                  ) : null}
                </div>


              </Col>
            </Row>
            {!!isEdit ? '' :
              <Row>

                <ShapeUpload selectFiles={setSelectedFiles} onReset={resetFiles} />
              </Row>
            }

          </ModalBody>

          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={() => {
              setmodal_backdrop(false);
            }}>Хаах</button>
            <button type="submit" className="btn btn-primary"> Хадгалах </button>
          </div>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default Detail;
